import React from 'react';
import styled from 'styled-components';

const Button = styled.div`
  width: 200px;
  height: 40px;
  margin-top: 20px;
  bottom: 10px;
  left: 25px;
  padding-left: 25px;
  line-height: 45px;
  border-radius: 2px;
  background-color: var(--color-gunmetal);
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
`;

interface Props {
  click: Function;
  ready: boolean;
  loading?: boolean;
  last?: boolean;
  middle?: boolean;
  style?: React.CSSProperties;
  title?: string;
}

export default function SaveButton(props: Props) {
  let icon: JSX.Element;

  let title = props.title ?? (props.last ? 'SUBMIT OFFER' : 'SAVE + CONTINUE');

  if (props.loading) icon = <div className="loader">Loading...</div>;
  else if (props.last)
    icon = (
      <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <circle fill="#FFF" cx="10" cy="10" r="10" />
          <path
            d="M7.18 9.663c-.714-.699-1.895.453-1.18 1.286l3.146 2.891 5.158-6.028c1.026-1.239-.369-2.191-1.327-1.135L8.995 11.33 7.181 9.663z"
            fill="#415859"
            fillRule="nonzero"
          />
        </g>
      </svg>
    );
  else
    icon = (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
          <g>
            <g>
              <g>
                <g transform="translate(-1068.000000, -670.000000) translate(912.000000, 660.000000) translate(156.000000, 10.000000)">
                  <circle cx="10" cy="10" r="10" fill="#FFF" />
                  <path
                    fill="#999"
                    d="M14.613 10.207c-.015.026-.03.047-.044.074-.026.052-.058.1-.096.143-.025.023-.053.043-.082.061l-1.896 2.809c-.26.346-.732.454-1.118.257-.183-.07-.324-.22-.383-.408-.06-.187-.03-.391.08-.555l1.288-1.913H6.518c-.409 0-.74-.331-.74-.74 0-.41.331-.74.74-.74h5.844l-1.289-1.913c-.109-.163-.138-.367-.079-.554.06-.187.2-.338.383-.409.386-.196.857-.087 1.118.258l1.881 2.786c.012.01.022.021.03.035.064.054.119.118.163.189.048.084.076.18.081.277.006.018.009.027.008.036 0 .012.007.022.007.034 0 .012-.007.023-.007.034 0 .01-.002.019-.008.026-.004.086-.017.15-.037.213z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );

  return (
    <Button
      onClick={props.ready ? props.click : () => {}}
      style={{
        opacity: props.ready ? 1.0 : 0.2,
        left: props.middle ? '128px' : '25px',
        display: 'inline-block',
      }}
    >
      <div className="float-left">{title}</div>
      <div className="float-right" style={{ marginTop: '-2px', paddingRight: '20px' }}>
        {icon}
      </div>
    </Button>
  );
}
